<mat-sidenav-container fullscreen>
  <mat-sidenav #sidenav mode="over" [fixedInViewport]="false" position="end" [autoFocus]="false">
    <mat-nav-list>
      <button mat-icon-button (click)="sidenav.close()" class="close-button">
        <mat-icon>close</mat-icon>
      </button>

      <wm-libs-auth-buttons (buttonClick)="onAuthButtonClick()" class="mt-2" [isAuth]="isAuth" [isDarkMode]="isDarkMode$" [wrap]="true"> </wm-libs-auth-buttons>

      <ng-container *ngIf="isAuth">
        <ng-container *ngIf="app === 'wm-tech'">
          <a mat-list-item href="{{ env.techMmsDomain }}" (click)="sidenav.close()">{{ 'WM_TECH.HEADER.MMS' | translate }}</a>
          <a mat-list-item href="{{ env.techPoolDomain }}" (click)="sidenav.close()">{{ 'WM_TECH.HEADER.POOL' | translate }}</a>
        </ng-container>
        <ng-container *ngIf="app === 'wm-tech-mms'">
          <a mat-list-item routerLink="/" routerLinkActive="active" (click)="sidenav.close()">{{ 'WM_TECH.HEADER.MMS' | translate }}</a>
          <a mat-list-item href="{{ env.techPoolDomain }}" (click)="sidenav.close()">{{ 'WM_TECH.HEADER.POOL' | translate }}</a>
        </ng-container>
        <ng-container *ngIf="app === 'wm-tech-pool'">
          <a mat-list-item href="{{ env.techMmsDomain }}" (click)="sidenav.close()">{{ 'WM_TECH.HEADER.MMS' | translate }}</a>
          <a mat-list-item routerLink="/" routerLinkActive="active" (click)="sidenav.close()">{{ 'WM_TECH.HEADER.POOL' | translate }}</a>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="app === 'wm-tech'; else hrefNavMenu">
        <a mat-list-item routerLink="/prices" routerLinkActive="active" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.MMS_PRICES' | translate }}</a>
        <a mat-list-item routerLink="/fees" routerLinkActive="active" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.POOL_FEES' | translate }}</a>
        <a mat-list-item routerLink="/support" routerLinkActive="active" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.SUPPORT' | translate }}</a>
        <a mat-list-item routerLink="/terms" routerLinkActive="active" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.TERMS' | translate }}</a>
        <a mat-list-item routerLink="/privacy" routerLinkActive="active" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.PRIVACY' | translate }}</a>
        <a mat-list-item routerLink="/faq" routerLinkActive="active" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.FAQ' | translate }}</a>
      </ng-container>
      <ng-template #hrefNavMenu>
        <a mat-list-item [href]="env.techDomain + '/prices'" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.MMS_PRICES' | translate }}</a>
        <a mat-list-item [href]="env.techDomain + '/fees'" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.POOL_FEES' | translate }}</a>
        <a mat-list-item [href]="env.techDomain + '/support'" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.SUPPORT' | translate }}</a>
        <a mat-list-item [href]="env.techDomain + '/terms'" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.TERMS' | translate }}</a>
        <a mat-list-item [href]="env.techDomain + '/privacy'" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.PRIVACY' | translate }}</a>
        <a mat-list-item [href]="env.techDomain + '/faq'" (click)="sidenav.close()">{{ 'WM_TECH.FOOTER.FAQ' | translate }}</a>
      </ng-template>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="wrapper">
      <wm-libs-header [app]="app" [env]="env" (menuToggle)="sidenav.toggle()" class="sticky" [balance]="balance"></wm-libs-header>
      <main class="content">
        <ng-content></ng-content>
      </main>
      <wm-libs-footer [env]="env" [useExternalLinks]="app !== 'wm-tech'"></wm-libs-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
